export const ENTRYPOINT_LINK = "https://www.entpnt.com/";
